"use client";

import Field from "@client/components/formik/field";
import Select from "@client/components/formik/select";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import { FormButton } from "@ui/js/components/buttons/form-button";
import Fieldset from "@ui/js/components/form/fieldset";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "nurse-specialty";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function NurseSpecialty() {
	const { setFieldValue } = useFormikContext();

	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};

	return (
		<>
			<Fieldset legend="What is your nursing specialty?">
				<Field
					{...setUserInteractionDataAttribute(
						`lead-form_step_${INPUT_ID_AND_LABEL_HTMLFOR}`,
					)}
					id={INPUT_ID_AND_LABEL_HTMLFOR}
					name={FIELD_NAME_SELECTOR}
					label="Nurse specialty"
				>
					<Select
						id={INPUT_ID_AND_LABEL_HTMLFOR}
						name={FIELD_NAME_SELECTOR}
						onChange={handleChange}
					>
						<option value="" disabled>
							Select a specialty
						</option>
						<option value="RN">Registered Nurse (RN)</option>
						<option value="LPN">Licensed Practical Nurse (LPN)</option>
						<option value="CNA">Certified Nursing Assistant (CNA)</option>
						<option value="APRN">
							Advanced Practice Registered Nurse (APRN)
						</option>
						<option value="nurse_educator">Nurse Educator</option>
						<option value="other">Other</option>
					</Select>
				</Field>
			</Fieldset>
			<FormButton
				{...setUserInteractionDataAttribute(
					`lead-form_submit-button_${INPUT_ID_AND_LABEL_HTMLFOR}`,
				)}
			/>
		</>
	);
}
